export const isLatestSessionRequest = (
  responseSessionId: number | null,
  currentSessionId: number | null,
  responseRequestToken: number,
  latestRequestToken: number,
): boolean => (
  responseSessionId === currentSessionId
  && responseRequestToken === latestRequestToken
)
